<div class="bg-white mat-elevation-z2 m-3">
  <div
    class="logs-header d-flex justify-content-between align-items-center p-2"
  >
    <div class="d-flex align-items-center p-2">
      <button
        mat-button
        class="back-icon text-muted me-2 mat-elevation-z8"
        (click)="goToAccountingPage()"
      >
        <mat-icon class="back-mat-icon">keyboard_backspace</mat-icon>
      </button>
      <h4 class="text-muted mb-0">Stripe Logs</h4>
      <span
        [ngClass]="
          status === 'Imported'
            ? 'imported-status'
            : status === 'Error'
              ? 'error-status'
              : 'default-status'
        "
      >
        @if (status === "Imported") {
          <img src="../../../../../assets/icons/Imported.png" alt="" />
        }
        @if (status === "Error") {
          <img src="../../../../../assets/icons/Failed.png" alt="" />
        }
        @if (status === "Open") {
          <img width="50px" src="../../../../../assets/icons/Open.png" alt="" />
        }
      </span>
    </div>
  </div>
  <section class="example-container p-4 bg-white table-layout-content" tabindex="0">
    @if (stripeData.length === 0) {
      <div class="p-4 text-center text-gray-500 italic">
        No transactions found for this category.
      </div>
    } @else {
      <div class="d-flex align-items-center table-responsive table-container-scroll">
        <div class="table-scroll-region w-100">
        <mat-table
          matSort
          class="custom-column-divider modern-table"
          (matSortChange)="sortData($event)"
          [dataSource]="stripeData"
        >
          <!-- Name Column -->
          @for (col of columns; track col.key) {
            <ng-container matColumnDef="{{ col.key }}">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="table-header-cell"
              >
                {{ col.label }}
              </th>
              <td mat-cell *matCellDef="let row" class="table-data-cell">
                {{ row[col.key] }}
              </td>
            </ng-container>
          }
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
            class="modern-table-header-row"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="modern-table-data-row"
          ></tr>
        </mat-table>
        </div>
      </div>
      <app-pagination-table
        class="rounded-lg bg-white table-pagination-fixed"
        [totalResults]="totalResults"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageOffset]="pageOffset"
        (pageChange)="onPageChange($event)"
      >
      </app-pagination-table>
    }
  </section>
</div>
